import { render, staticRenderFns } from "./CodaUpload.vue?vue&type=template&id=a1fbaa86"
import script from "./CodaUpload.vue?vue&type=script&lang=ts"
export * from "./CodaUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1fbaa86')) {
      api.createRecord('a1fbaa86', component.options)
    } else {
      api.reload('a1fbaa86', component.options)
    }
    module.hot.accept("./CodaUpload.vue?vue&type=template&id=a1fbaa86", function () {
      api.rerender('a1fbaa86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/CodaUpload.vue"
export default component.exports